import { DownloadOutlined } from '@ant-design/icons'
import { Button } from '@sureco/design-system'
import { message } from 'antd'
import { downloadFile } from 'helpers/download-file'
import React, { useState } from 'react'
import {
  CensusReviewCsvDownloadType,
  downloadCensusReviewCsvReport,
} from '../../api/census-enrollment-platform-api-client'

interface CensusReviewCsvExportButtonProps {
  publicKey: string
  exportType: CensusReviewCsvDownloadType
  iconOnly?: boolean
}

const CensusReviewCsvExportButton = ({
  publicKey,
  exportType,
  iconOnly = false,
}: CensusReviewCsvExportButtonProps) => {
  const [loading, setLoading] = useState(false)

  const handleDownload = async () => {
    setLoading(true)
    try {
      const { blob, fileName } = await downloadCensusReviewCsvReport(
        publicKey,
        exportType
      )
      downloadFile(blob, fileName, 'text/csv;charset=utf-8;')
      message.success('Report downloaded successfully')
    } catch (error: any) {
      console.error('Census Review CSV export failed:', error)
      if (error?.response?.status === 403) {
        message.error('Only platform admins can export Census Review tabs.')
      } else {
        message.error('Failed to download report.')
      }
    } finally {
      setLoading(false)
    }
  }

  return (
    <Button
      size="large"
      variant={iconOnly ? 'ghost' : 'darkblue'}
      type="outline"
      disabled={loading}
      onClick={handleDownload}
      loading={loading}
      title="Download Report"
      aria-label="Download Report"
      style={{
        padding: iconOnly ? 0 : '8px 16px',
      }}
    >
      <DownloadOutlined
        style={{
          marginRight: iconOnly ? 0 : '8px',
        }}
      />
      {iconOnly ? null : 'Download Report'}
    </Button>
  )
}

export default CensusReviewCsvExportButton
